(() => {
  const root = document.querySelector('[data-mobile-login]')
  if (!root) return
  const api = window.__NOCALO__?.otpApiUrl
  const sendBtn = root.querySelector('[data-otp-send]')
  const verifyBtn = root.querySelector('[data-otp-verify]')
  const phoneInput = root.querySelector('[data-otp-phone]')
  const codeInput = root.querySelector('[data-otp-code]')
  const stepCode = root.querySelector('[data-otp-step-code]')
  const message = root.querySelector('[data-otp-message]')
  const results = root.querySelector('[data-otp-results]')

  function setMessage(text, isError = false) {
    if (!message) return
    message.textContent = text || ''
    message.hidden = !text
    message.classList.toggle('is-error', isError)
  }

  function formatMoney(amount, currency) {
    if (amount == null) return ''
    const value = Number(amount).toFixed(2)
    if (currency === 'INR') return `₹${value}`
    return `${currency} ${value}`
  }

  function renderOrders(orders) {
    if (!results) return
    if (!orders.length) {
      results.innerHTML = '<p class="shop-lede">No orders found for this mobile number.</p>'
      return
    }
    results.innerHTML = `<ul class="track-order__list">${orders
      .map(
        (order) => `<li class="track-order__item">
          <div>
            <a href="${order.statusUrl || '#'}">${order.name}</a>
            <p>${order.date ? new Date(order.date).toLocaleDateString('en-IN') : ''} · ${order.financialStatus || ''} · ${order.fulfillmentStatus || ''}</p>
          </div>
          <strong>${formatMoney(order.total, order.currency)}</strong>
        </li>`
      )
      .join('')}</ul>`
  }

  async function post(path, body) {
    if (!api) throw new Error('Mobile login is not connected yet.')
    const res = await fetch(`${api.replace(/\/$/, '')}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) throw new Error(data.error || 'Request failed')
    return data
  }

  sendBtn?.addEventListener('click', async () => {
    setMessage('')
    sendBtn.disabled = true
    try {
      const data = await post('/send', { phone: phoneInput.value })
      stepCode.hidden = false
      codeInput.focus()
      setMessage(data.devCode ? `Dev code: ${data.devCode}` : 'Code sent to your mobile.')
    } catch (error) {
      setMessage(error.message, true)
    } finally {
      sendBtn.disabled = false
    }
  })

  verifyBtn?.addEventListener('click', async () => {
    setMessage('')
    verifyBtn.disabled = true
    try {
      const data = await post('/verify', { phone: phoneInput.value, code: codeInput.value })
      setMessage('Signed in with mobile.')
      renderOrders(data.orders || [])
    } catch (error) {
      setMessage(error.message, true)
    } finally {
      verifyBtn.disabled = false
    }
  })
})()
